<ion-row class="error-container">
  <ion-col size="1">
    <img class="yield" [src]="IMAGES.YIELD_BROWN" />
  </ion-col>
  <ion-col class="error-text">
    <div>
      <div class="error-header">
        {{
          CONSTS.ERROR_TEXT_1.replace(
            "%s",
            route.snapshot.queryParamMap.get("userId") || ""
          )
        }}
      </div>
      <div>
        {{ CONSTS.ERROR_TEXT_2 }}
      </div>
    </div>
  </ion-col>
</ion-row>
